// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionBreadcrumbActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var setPropTypes = require('recompose').setPropTypes;

  var ACTIVE_CLASS = 'izenda-PermissionBreadcrumb_active';
  const { curry } = require('lodash/fp');
  var PermissionBreadcrumbActions = compose(
    setPropTypes({
      permissionStore: React.PropTypes.object.isRequired
    }),
    withHandlers({
      toggleAll: curry(toggleAll),
      getActive: curry(getActive),
      setActive: curry(setActive),
      removeActiveClass: curry(removeActiveClass)
    })
  );

  /**
   * Toggle all section
   * @param {Object} props
   */
  function toggleAll(props, isShow) {
    return function() {
      props.permissionStore.toggleAll(isShow);
    };
  }

  /**
   * Get active
   * @param {Object} props
   * @param {String} section
   * @returns {String} active class
   */
  function getActive(props, section) {
    return section === props.permissionStore.model.section ? ACTIVE_CLASS : null;
  }

  /**
   * Set active
   * @param {Object} props
   * @param {Object} Event
   */
  function setActive(props, section, e) {
    props.permissionStore.model.isClickedSection = true;
    removeActiveClass(props, e);
    $izenda(e.target).addClass(ACTIVE_CLASS);
    hashLinkScroll(section);
  }

  /**
   * Hash link scroll
   * @param {Object} section
   */
  function hashLinkScroll(section) {
    var element = document.getElementsByClassName(section)[0];
    if (element) element.scrollIntoView();
  }

  /**
   * Remove active class
   * @param {Object} props
   */
  function removeActiveClass(props, _) {
    $izenda('.izenda-PermissionBreadcrumb span, .izenda-PermissionBreadcrumb a').removeClass(
      'izenda-PermissionBreadcrumb_active'
    );
  }

  module.exports = PermissionBreadcrumbActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/Izenda.PermissionBreadcrumbActions.js